export const MicrosoftLogo: FC = ({ className }) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24">
    <rect fill="#4BB400" height="9.52382" width="9.52382" x="12.4762" y="2" />
    <rect fill="#FEB102" height="9.52382" width="9.52382" x="12.4762" y="12.4762" />
    <rect fill="#FF481E" height="9.52382" width="9.52382" x="2" y="2" />
    <rect fill="#0297D4" height="9.52382" width="9.52382" x="2" y="12.4762" />
  </svg>
);
